import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import EditUsersRolesTabs from '../addEditUser/editUsersRolesTabs';
import Dialog from 'material-ui/Dialog';
import { DialogHeader, Button, ButtonType } from '@checkmarx/cx-ui';

@inject('translationsStore') @observer
export default class EditUsersRolesDialog extends Component {

    render () {

        const actions = <div className='edit-roles-user-form-buttons-container'>
                            <span className='portal-blank-button' onClick={this.props.onClose} data-cy='cancel-user-button'>
                                {this.props.translationsStore.translate('CANCEL')}
                            </span>
                            <Button
                                dataCy='edit-user-roles-button'
                                onClick={this.props.onSubmit}
                                text={this.props.translationsStore.translate('SAVE')}
                                inProgress={this.props.inProgress}>
                            </Button>
                        </div>; 
        return <Dialog
                    open={this.props.isOpenEditRolesDialog}
                    repositionOnUpdate={false}
                    displayCloseButton
                    actionsContainerStyle={{padding: 0}}
                    contentStyle={{width: '480px'}}
                    actions={actions}
                    >
                    <DialogHeader
                        title={this.props.translationsStore.translate('EDIT_ROLES')}
                        displayCloseButton
                        closeClick={this.props.onClose}
                    />
                     <div style={{whiteSpace: 'pre-line', marginTop: '10px', marginBottom: '10px'}}>
                        {`${this.props.translationsStore.translate('ADD_REMOVE_HELP_TOOLTIP')}`}
                    </div>
                    <EditUsersRolesTabs/>       
                </Dialog>;
    }
}


// WEBPACK FOOTER //
// ./src/components/users/editBulkUsers/editUsersRolesDialog.jsx